import { FaInfoCircle } from "react-icons/fa";
import { useTranslations } from "src/apps/hooks/useTranslations";

import { REPRESENTATIVE_INFO } from "../RepresentedEntityDataForm.constants";
import { IconContainer, InfoMessage, InfoText } from "../RepresentedEntityDataForm.styles";
import { colors } from "@permisso/permisso-components";

export const RepresentativeInfoMessage = () => {
  const { t } = useTranslations();
  return (
    <InfoMessage>
      <IconContainer>
        <FaInfoCircle size={"16px"} color={colors.grey700} />
      </IconContainer>
      <InfoText>{t(REPRESENTATIVE_INFO)}</InfoText>
    </InfoMessage>
  );
};
